module.exports = import("https://maps.googleapis.com/maps/api/js?key=AIzaSyCOwvXXW58_h6sPslB047AFf3XkeSDLcbU&callback=Function.prototype");;